import { useEffect, useState } from 'react';

import { TEST_MODE_COOKIE_NAME } from 'constants/cookies';
import { hasCookie } from 'utils/cookies';

/**
 * Hook that will tell if testmode is active
 */
export function useTestmode(): boolean {
	const [testmode, setTestmode] = useState<boolean>(false);

	useEffect(() => {
		setTestmode(hasCookie(TEST_MODE_COOKIE_NAME));
	}, []);

	return testmode;
}
